import Component from "@ember/component"
import { computed, get } from "@ember/object"
import { alias } from "@ember/object/computed"
import { inject as service } from "@ember/service"
import findDocument from "cc-frontend/helpers/find-document"
import findMany from "cc-frontend/helpers/find-many"

export default class InteriorPrintModal extends Component {
  @service("ember-store")
  store

  @service
  appState

  @service
  session

  @service
  modalManager

  @computed("session.user.attributes.printOptions")
  get lastPrintOptions() {
    return get(this, "session.user.attributes.printOptions")
  }

  @computed("session.user.attributes.firstName", "session.user.attributes.lastName")
  get fullName() {
    return (
      get(this, "session.user.attributes.firstName") +
      " " +
      get(this, "session.user.attributes.lastName")
    )
  }

  // I think we should change this to a subscription service
  @alias("session.user.attributes.isPro")
  needsToUpgradeToPrint

  @findDocument("courseId", "course")
  course

  @findMany("courseIds", "course")
  courses

  @findDocument("planbookId", "planbook")
  planbook
}
